import isEmail from 'validator/lib/isEmail';
import { wrongDomains } from "./domainSpellingUtils";
function hasMinLength(text) {
  var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
  var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 256;
  return text.length >= min && text.length < max;
}
function hasUpperAndLowercase(text) {
  return /^(?=.*[a-z])(?=.*[A-Z]).*$/.test(text);
}
function hasSpecialChars(text) {
  return /^((?=.*\d)|(?=.*?[#?!@$%^&*-])).*$/.test(text);
}
function validatePassword(password) {
  return /^(?=.*[a-z])(?=.*[A-Z])((?=.*\d)|(?=.*?[#?!@$%^&*-])).{6,}$/.test(password);
}
function isValidEmail(email) {
  return isEmail(email) && email[0] !== '"';
}
function domainSpellingCheck(email) {
  if (!email) return;
  var emailParts = email.split('@');
  var domain = emailParts[1];
  if (wrongDomains[domain]) {
    return {
      domain: wrongDomains[domain],
      email: "".concat(emailParts[0], "@").concat(wrongDomains[domain])
    };
  }
  return undefined;
}
export { isValidEmail, hasMinLength, hasSpecialChars, validatePassword, domainSpellingCheck, hasUpperAndLowercase };